export enum SignInSteps {
  EMAIL = 'email',
  PASSWORD = 'password',
}

export enum SignInActions {
  RESOLVE_ACCOUNT_TYPE = 'resolve_account_type',
  AUTHENTICATE = 'authenticate',
}
